import { render, staticRenderFns } from "./PopUpBannersEdit.vue?vue&type=template&id=3461277c&scoped=true"
import script from "./PopUpBannersEdit.vue?vue&type=script&lang=js"
export * from "./PopUpBannersEdit.vue?vue&type=script&lang=js"
import style0 from "./PopUpBannersEdit.vue?vue&type=style&index=0&id=3461277c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3461277c",
  null
  
)

export default component.exports